import React, { useState, useEffect, useContext } from "react";
import Icon1 from "../../../../images/svg-1.svg";
import Icon2 from "../../../../images/svg-2.svg";
import Icon3 from "../../../../images/svg-3.svg";
import locationBg from "../../../../images/locationBg.png";
import {
  ServicesContainer,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH1,
  ServicesH2,
  ServicesP,
  InputFeild,
} from "./ServiceElements";
import * as PA from "./ServiceElements";
import { FiSearch } from "react-icons/fi";
import PropertyData from "./PropertyData";
import PlacesAutocomplete, { geocodeByAddress, geocodeByPlaceId, getLatLng } from "react-places-autocomplete";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { withRouter } from "react-router-dom";
import axios from "../../../../axios";
import { toast } from "react-toastify";
import Select from "../../../../components/Select";
import Overlay from "../../../../components/DotLoader";
import { DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { LanguageContext } from "../../../../utils/language/Language";

const Services = ({ userData, history }) => {
  const [center, setCenter] = useState();
  const [addresses, setAddresses] = useState("");
  const [type, setTypes] = useState([]);
  const [typeState, setTypeState] = useState("");
  const [saleType, setSaleType] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPos, setCurrentPos] = useState(null);
  const { dictionary } = useContext(LanguageContext);
  const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

  console.log(typeState)
  console.log({type}) 
  const typeData = async (option) => {
    setIsLoading(true);
    try {
      let { data } = await axios.get("/property-type");
      console.log("data is -->>", data);
      setTypes(data?.data);
      setTypeState(data?.data[0]?.key);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    typeData();
  }, []);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((currentPos) => {
      setCurrentPos({
        lat: currentPos.coords.latitude || "",
        lng: currentPos.coords.longitude || "",
      });
    });
  }, []);

  const showUnitOptions = [
    {
      label: dictionary.menzilString.Select,
      value: "0",
    },
    {
      label: dictionary.menzilString.For_Sale,
      value: "1",
    },
    {
      label: dictionary.menzilString.For_Lease,
      value: "2",
    },
  ];

  return (
    <>
      <ServicesContainer id="services">
        <PA.PropertySearchBox>
          <PA.PropertyTypes>
            {type?.map((item) => (
              <PA.PropertyText
                onClick={() => {
                  setTypeState(item?.key);
                }}
                style={
                  item.key === typeState ? { borderBottom: "3px solid #ED7D2B" } : { borderBottom: "3px solid transparent" }
                }
              >
                <PA.TypeText style={item.key === typeState ? { color: "#ED7D2B" } : { color: "unset" }}>
                  {item?.value}
                </PA.TypeText>
              </PA.PropertyText>
            ))}
          </PA.PropertyTypes>
          <PA.PropertyDividerLine></PA.PropertyDividerLine>
          <PA.PropertySearch>
            <PA.PropertySaleButton
              className={defaultLanguage === "ar" ? "type-arabic type-select" : "type-select"}
            >
              <Select
                isSearchable={false}
                isClearable={false}
                defaultValue={{ label: dictionary.menzilString.Select, value:0}}
                options={showUnitOptions}
                onChange={(option) => {
                  setSaleType(option.value);
                }}
              />
              
            </PA.PropertySaleButton>
            <PA.PrSearchBox>
              <PA.PropertySearchIcon>
                <FiSearch />
              </PA.PropertySearchIcon>
              <PlacesAutocomplete
                value={addresses}
                onChange={(e) => {
                  // console.log(e);
                  // formikBag.setFieldValue("lat", "");
                  // formikBag.setFieldValue("long", "");
                  // formikBag.setFieldValue("restaurant_location", e);
                  setAddresses(e);
                }}
                onSelect={async (value) => {
                  const results = await geocodeByAddress(value);
                  const ll = await getLatLng(results[0]);

                  console.log(ll);
                  // console.log(results);
                  setCenter({ lat: ll?.lat || "", lng: ll?.lng || "" });
                  setAddresses(value);
                  history.push(
                    `/search-property?lat=${ll?.lat || ""}&long=${ll?.lng || ""}&sale_type=${saleType}&property_type=${typeState}`
                  );
                  // formikBag.setFieldValue("restaurant_location", value);
                  // formikBag.setFieldValue("lat", ll.lat);
                  // formikBag.setFieldValue("long", ll.lng);
                  // setCoordinates(ll)
                }}
              >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                  <div style={{ width: "100%" }} className="d-flex">
                    <InputFeild
                      {...getInputProps({
                        placeholder: dictionary.menzilString.Enter_an_address,
                        className: "location-search-input",
                      })}
                      // className="form-control"
                    />
                    <div className="autocomplete-dropdown-container location-dropdown" style={{ top: "60px" }}>
                      {loading && <div>Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? { backgroundColor: "#fafafa", cursor: "pointer", color: "black" }
                          : { backgroundColor: "#ffffff", cursor: "pointer", color: "black" };
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
              <PA.PropertyLocation src={locationBg}></PA.PropertyLocation>
            </PA.PrSearchBox>
            <PA.PropertySearchButton
              onClick={() => {
                history.push(
                  `/search-property?lat=${currentPos?.lat}&long=${currentPos?.lng}&sale_type=${saleType}&property_type=${typeState}`
                );
              }}
            >
              {dictionary.menzilString.Search}
            </PA.PropertySearchButton>
          </PA.PropertySearch>
        </PA.PropertySearchBox>

        <PropertyData />
      </ServicesContainer>
      {isLoading && <Overlay backgroundColor={true} />}
    </>
  );
};

// export default Services;
const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Services));
